import React, { Component } from 'react';
import BulkChangeConfigurator from '../../components/bulk-change-configurator/BulkChangeConfigurator';
import s from './HostStyles.module.scss';

/**
 * The BulkChangeConfiguratorHost acts as the base that will trigger the BulkChangeConfigurator (AKA the Bulk Editor). It
 * consists of a button that will trigger the Bulk Editor when clicked. When the Bulk Editor is exited, it will cause <pre></pre>
 * to appear that lists the changes that were made between opening the Bulk Editor and saving (triggered within the Bulk Editor).
 * The state of the following variables are passed down to the Bulk Editor:
 *
 * @param {boolean} modalOpen: Whether the Bulk Editor modal is open
 * @param {object} configuredChanges: Stores all the changed values from the bulk editor
 * @param {boolean} saving: When the save button is pressed and the modeal, saving is set to true. Once saved, set to false again
 *
 */
export default class BulkChangeConfiguratorHost extends Component {
    constructor(props) {
        super(props);
        this.state = { modalOpen: true, configuredChanges: null, saving: false };
    }

    /**
     * Sets modalOpen to true, triggering the Bulk Editor to open
     *
     */
    openModal = () => {
        this.setState({ modalOpen: true, configuredChanges: null });
    };

    /**
     * Sets modalOpen to false, closing the Bulk Editor, as well as saving and displaying the results. Called from BulkChangeConfigurator.js
     * @param {object} result: the object that is storing all the changes from the Bulk Editor
     *
     */
    closeModal = result => {
        if (result) {
            this.setState({ saving: true });
            setTimeout(() => this.setState({ modalOpen: false, configuredChanges: result, saving: false }), 1000);
        } else {
            this.setState({ modalOpen: false, configuredChanges: 'cancelled' });
        }
    };

    render() {
        const { modalOpen, configuredChanges, saving } = this.state;

        return (
            <div className={s.editor}>
                <button type="button" onClick={this.openModal}>
                    Show Modal
                </button>
                {configuredChanges && (
                    <pre>
                        The following changes were configured:
                        {JSON.stringify(configuredChanges, null, 2)}
                    </pre>
                )}
                <BulkChangeConfigurator open={modalOpen} onClose={this.closeModal} saving={saving} />
            </div>
        );
    }
}
